// For input type tel (for mobile keyboard users), allowing only number to be Input.
// Also since type number has been having issues with internet explorer

import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

// Tested with Regex Previewer extension
// Type checked with TS's regex interface to make sure
const numbers: RegExp = /\D/g;

@Directive({
	selector: '[appNumbersOnly]',
})
export class NumbersOnlyDirective {
	constructor(private control: NgControl) {}
	@HostListener('input', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		const input = event.target as HTMLInputElement;
		if (input.value) {
			const x = input.value.replace(numbers, '');
			if (x !== input.value) {
				if (this.control) {
					if (this.control.control) {
						this.control.control.setValue(x);
					}
					this.control.valueAccessor.writeValue(x);
					this.control.viewToModelUpdate(x);
				}
			}
		}
	}
}
